function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Tabs, Form, Upload, Button, List, notification, Alert, Skeleton, Input, Modal, Drawer } from 'antd';
import { Upload as UploadIc, CardHeading } from "react-bootstrap-icons";
import { Row, Col } from 'react-bootstrap';
import Moment from "react-moment";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var ManagerSignaturePadView = function ManagerSignaturePadView(_ref) {
  var userId = _ref.userId;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    documentList = _useState2[0],
    setDocumentList = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pad = _useState4[0],
    setPad = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataChanged = _useState8[0],
    setIsDataChanged = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isFormLoading = _useState0[0],
    setIsFormLoading = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    file = _useState10[0],
    setFile = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    formError = _useState12[0],
    setFormError = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    formSuccess = _useState14[0],
    setFormSuccess = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItem = _useState16[0],
    setSelectedItem = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isDocumentVisivble = _useState18[0],
    setIsDocumentVisible = _useState18[1];
  var onFinish = function onFinish(values) {
    setFormError("");
    setFormSuccess("");
    setIsFormLoading(true);
    var formData = new FormData();
    formData.append("description", values.description);
    formData.append("user_id", Common.currentUser.id);
    formData.append("signature_pad_id", pad.id);
    formData.append("document_type", "new");
    formData.append("file", file);
    formData.append("status", 0);
    formData.append("display", 1);
    axios.post(Common.baseApiUrl + "additemtosp", formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess(response.data.message);
        setIsDataChanged(true);
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError("Une erreur est survenue");
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var handleWithdraw = function handleWithdraw(item) {
    setSelectedItem(item);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("b", {
        children: ["Le retrait de - ", item.description, " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'removeitemtosp', {
          user_id: Common.currentUser.id,
          signature_pad_item_id: item.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Apération réussie !",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Verifiez votre connexion internet"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleShowDocument = function handleShowDocument(item) {
    setSelectedItem(item);
    setIsDocumentVisible(true);
  };
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  useEffect(function () {
    setIsDataChanged(false);
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getmanagersignaturepad/").concat(userId)).then(function (response) {
      if (response.data.status == 200) {
        setPad(response.data.pad);
        setDocumentList(response.data.pad.items.filter(function (i) {
          return i.display == 1;
        }));
      } else {
        notification.info({
          message: "Introuvable",
          description: "Parafeur introuvable pour cet utilisateur"
        });
      }
    })["catch"](function (error) {
      notification.info({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [pad != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsx(List, {
            size: "large",
            bordered: true,
            style: {
              background: "#FFFFFF"
            },
            dataSource: documentList,
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                actions: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    handleShowDocument(item);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "APERCU"
                  })
                })],
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  avatar: /*#__PURE__*/_jsx(CardHeading, {
                    size: 30
                  }),
                  title: /*#__PURE__*/_jsx(Moment, {
                    format: "DD/MM/YYYY HH:mm",
                    date: item.created_at
                  }),
                  description: /*#__PURE__*/_jsx("span", {
                    style: {
                      textTransform: "uppercase"
                    },
                    children: item.description
                  })
                })
              });
            }
          })
        })
      })
    }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), !isDataLoading && pad == null && /*#__PURE__*/_jsx("h3", {
      style: {
        textAlign: 'center',
        color: "grey"
      },
      children: "AUCUN PARAFEUR TROUVE"
    }), selectedItem != null && isDocumentVisivble == true && /*#__PURE__*/_jsx(Drawer, {
      title: selectedItem.description,
      open: isDocumentVisivble,
      destroyOnClose: true,
      width: "550px",
      onClose: function onClose() {
        setIsDocumentVisible(false);
      },
      children: /*#__PURE__*/_jsx(DocViewer, {
        documents: [{
          uri: Common.baseUrl + selectedItem.document_url
        }],
        pluginRenderers: DocViewerRenderers,
        language: "fr",
        config: {
          header: {
            disableHeader: false,
            disableFileName: true
          }
        }
      })
    })]
  });
};
export default ManagerSignaturePadView;